const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/backend/logicfusion/LogicFusion-USER/user`;
// const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/logicfusion/LogicFusion-USER/user`;

export default API_BASE_URL;
